import { render, staticRenderFns } from "./AuthorityApply.vue?vue&type=template&id=952480cc&scoped=true&"
import script from "./AuthorityApply.vue?vue&type=script&lang=js&"
export * from "./AuthorityApply.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityApply.vue?vue&type=style&index=0&id=952480cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952480cc",
  null
  
)

export default component.exports